import React, { useState } from 'react';
import axiosInstance from '../../../redux/helpers/axiosInstance';
import './systemAssistant.scss';

const SUGGESTED = [
  'How is the risk score calculated?',
  'What is the loan maturity check?',
  'Does the system use social media data?'
];

const SystemAssistant = () => {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState(null);
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const askQuestion = async (q) => {
    const text = (q ?? question).trim();
    if (text.length < 3) return;

    setLoading(true);
    setError(null);
    setAnswer(null);
    setSources([]);

    try {
      const { data } = await axiosInstance.post('/rag/ask', { question: text });
      setAnswer(data.data.answer);
      setSources(data.data.sources ?? []);
    } catch (err) {
      setError(err.response?.data?.message ?? 'Could not get an answer. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      askQuestion();
    }
  };

  return (
    <section className="sys-assistant">
      <header className="sys-assistant__head">
        <span className="sys-assistant__tag">Ask about the system</span>
        <span className="sys-assistant__hint">
          Ask how CreditFlow assesses applications — answers come from the system documentation.
        </span>
      </header>

      <div className="sys-assistant__input-row">
        <input
          type="text"
          className="sys-assistant__input"
          placeholder="e.g. How is the risk score calculated?"
          value={question}
          onChange={(e) => {
            const val = e.target.value;
            setQuestion(val);
            if (val.trim() === '' && answer) {
              setAnswer(null);
              setSources([]);
            }
          }}
          //   onChange={(e) => {
          //     setQuestion(e.target.value);
          //     // Clear the previous answer once the user edits the question.
          //     if (answer) {
          //       setAnswer(null);
          //       setSources([]);
          //     }
          //     if (error) setError(null);
          //   }}
          onKeyDown={handleKeyDown}
          disabled={loading}
        />
        <button
          type="button"
          className="sys-assistant__ask"
          onClick={() => askQuestion()}
          disabled={loading || question.trim().length < 3}>
          {loading ? 'Thinking…' : 'Ask'}
        </button>
      </div>

      {!answer && !loading && (
        <div className="sys-assistant__suggestions">
          {SUGGESTED.map((s) => (
            <button
              key={s}
              type="button"
              className="sys-assistant__chip"
              onClick={() => {
                setQuestion(s);
                askQuestion(s);
              }}>
              {s}
            </button>
          ))}
        </div>
      )}

      {error && (
        <p className="sys-assistant__error" role="alert">
          {error}
        </p>
      )}

      {answer && (
        <div className="sys-assistant__answer">
          <p className="sys-assistant__answer-text">{answer}</p>
          {sources.length > 0 && (
            <div className="sys-assistant__sources">
              <span className="sys-assistant__sources-label">Based on</span>
              {sources.map((s, i) => (
                <span key={i} className="sys-assistant__source">
                  {s.source}
                </span>
              ))}
            </div>
          )}
          <span className="sys-assistant__disclaimer">
            Answers describe how the system works — they are not a decision on this application.
          </span>
        </div>
      )}
    </section>
  );
};

export default SystemAssistant;
